module.exports = __webpack_public_path__ + "static/media/fr.pictogram.2ecd8f05.svg";